import React from 'react';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/line';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import http from '../../../../axios/http';

const xData = ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
const yData = [
	[13112, 11125, 14787, 14195, 13086, 12266, 12011, 12544, 13541, 14562, 13955, 14002],
	[11458, 11458, 13971, 14491, 13282, 12666, 11901, 13052, 12741, 14863, 14365, 14106],
	[-2.01, 2.99, -5.52, 2.09, 1.50, 3.26, -0.92, 4.05, -5.91, 2.07, 2.94, 0.74]
];

const colorList = ['#0DAFF4', '#FFDB5C', '#ff7c7c', '#60acfc', '#32d3eb', '#5bc49f', '#feb64d', '#9287e7'];

class ChartBar extends React.Component {

	state = {
		myChart: {},
		fontColor: ['#ffffff', '#000000'],
		amount: [],
		carNum: [],
	}
	componentWillMount() {

	}
	componentDidMount() {
		let date = new Date();
		let getYear = date.getFullYear();
		http.post({
			url: '/applySummary/findTradePriceStatictic',
			data: { year: getYear },
			success: (res) => {
				for (let i = 0; i < res.amount.length; i++) {
					if (res.amount[i] == null) {
						res.amount[i] = 0;
					}
				}
				this.setState({
					amount: res.amount,
					carNum: res.num
				})
				// 初始化
				let myChart = echarts.init(document.getElementById(this.props.domId));
				let option = this.getOption();
				// 绘制图表
				myChart.setOption(option);
				this.setState({ myChart: myChart });
			}
		});

		window.addEventListener('resize', this.handleResize, false);

	}

	getOption = () => {
		let date = new Date();
		let year = date.getFullYear();
		let month = date.getMonth() + 1;
		let curYear = year + '年';
		let curData = yData[1].slice(0, month);
		let rateData = yData[2].slice(0, month);
		curData[month - 1] = (curData[month - 1] * date.getDate() / 30).toFixed(0);
		rateData[month - 1] = ((curData[month - 1] - yData[0][month - 1]) / 0.01 / yData[0][month - 1]).toFixed(2);
		let option = {
			color: colorList,
			title: {
				text: curYear + '厦门二手车月度交易趋势',
				x: 'center',
				y: 'top',
				textStyle: {
					// color: this.state.fontColor[this.props.isFullScreen?0:1],
					color: '#fff'
				}
			},
			legend: {
				y: '30',
				data: ['交易数量', '价格统计'],
				textStyle: {
					color: '#fff'
				}
			},
			tooltip: {
				trigger: 'axis',
				axisPointer: {            // 坐标轴指示器，坐标轴触发有效
					type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
				},
				formatter: function (params, ticket, callback) {
					let res = params[0].name;
					for (let i = 0; i < params.length; i++) {
						res += '<br/>' + params[i].seriesName + ' : ' + params[i].value;
					}
					return res;
				}
			},
			grid: {
				left: '0%',
				right: '0%',
				bottom: '0%',
				containLabel: true
			},
			xAxis: [
				{
					type: 'category',
					data: xData,
					axisTick: {
						alignWithLabel: true
					},
					axisLine: {
						lineStyle: {
							color: '#fff',
						}
					}
				}
			],
			yAxis: [
				{
					type: 'value',
					name: '交易数量',
					splitLine: { show: false },
					axisLabel: {
						formatter: '{value}'
					},
					axisLine: {
						lineStyle: {
							color: '#fff',
						}
					}
				}, {
					type: 'value',
					name: '价格统计',
					splitLine: { show: false },
					axisLabel: {
						formatter: '{value}'
					},
					axisLine: {
						lineStyle: {
							color: '#fff',
						}
					}
				}
			],
			series: [
				{
					name: '交易数量',
					type: 'bar',
					yAxisIndex: 0,
					data: this.state.carNum,
					itemStyle:{//
						normal: {
							  color: new echarts.graphic.LinearGradient(
								  0, 0, 0, 1,
								  [
									  {offset: 0, color: '#f485ff'},
									  {offset: 0.5, color: '#22f6f6'},
									  {offset: 1, color: '#22f6f6'}
								  ]
							  )
						  },
					  }
				},
				{
					name: '价格统计',
					type: 'bar',
					yAxisIndex: 1,
					data: this.state.amount,
					itemStyle:{//
						normal: {
							  color: new echarts.graphic.LinearGradient(
								  0, 0, 0, 1,
								  [
									  {offset: 0, color: '#005efa'},
									  {offset: 0.5, color: '#005efa'},
									  {offset: 1, color: '#7c7fff'}
								  ]
							  )
						  },
					  }
				},

			]
		};
		return option;
	}

	componentWillUnmount() {
		//一定要最后移除监听器，以防多个组件之间导致this的指向紊乱
		window.removeEventListener('resize', this.handleResize, false);
	}

	handleResize = e => {
		this.state.myChart.setOption(this.getOption());
		this.state.myChart.resize();
	}

	render() {
		return (
			<div id={this.props.domId} style={{ width: '100%', height: '100%' }}></div>
		);
	}
}

export default ChartBar;